export function initGlossaryAlphabetJsTagNavigation() {
    document.querySelectorAll('.tag-js-navigate-to')
        .forEach(function (/** @type {HTMLElement} */ item) {
            item.addEventListener('click', navigationHandler);
            item.addEventListener('keypress', keyboardEventHandler);
        });
}

/**
 * Basic navigation-related event handler.
 * 
 * @param {Event} event 
 */
function navigationHandler(event) {
    if (event.target.dataset.navigateTo) {
        var urlToNavigate = new URL(
            event.target.dataset.navigateTo,
            location.href
        );
        self.location.assign(urlToNavigate);
    }
}

/**
 * Pressing 'Space' or 'Enter' when focused on the tag element
 * should trigger window navigation.
 * 
 * @param {KeyboardEvent} event 
 */
function keyboardEventHandler(event) {
    if (event.altKey) {
        return;
    }

    switch (event.code) {
        case 'Space':
        case 'Enter':
            event.preventDefault();
            navigationHandler(event);
            break;
        default:
            // No special action in this case
            break;
    }
}
